module.exports = __webpack_public_path__ + "img/1.d5fa4fdf.png";